<div class="h-full flex flex-col items-center justify-center p-4">
  <div class="overflow-auto max-h-[calc(100%-3rem)] flex items-center justify-center bg-white">
    <img 
      *ngIf="imageUrl" 
      [src]="imageUrl" 
      alt="Image preview" 
      class="max-w-full max-h-full object-contain"
    />
    <div *ngIf="!imageUrl" class="text-center py-8">
      No image to display
    </div>
  </div>
</div>
